import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const compareFlexibleProducts = (product1, product2, numOfYears, existingFlexibleMembership) => {
  const url = apiConstants.CompareFlexibleProducts;

  const products = {
    ExistingFlexibleMembership: existingFlexibleMembership,
    NumOfYears: numOfYears,
    Product1: product1,
    Product2: product2,
  };

  products.Product1.flexiblePackageCostProportion = parseFloat(
    `0.${product1.flexiblePackageCostProportion}`
  );
  products.Product2.flexiblePackageCostProportion = parseFloat(
    `0.${product2.flexiblePackageCostProportion}`
  );

  return httpClient.post(url, products).then((result) => result.data);
};

export { compareFlexibleProducts };
